export default __webpack_public_path__ + "static/media/smiley.74c01679.gif";